module.exports = __webpack_public_path__ + "static/media/analog.21ba1a9b.png";